// extracted by mini-css-extract-plugin
export default {"rootElement":"XavVI__rootElement","chartOutput":"_2MpoB__chartOutput","legendOutput":"Ika2d__legendOutput","noData":"j80q3__noData"};